import React from "react";

const Tab = ({ title, children }) => <div>{children}</div>;

export default Tab;
